import { produce } from 'immer';
import {
    LOAD_ACCOUNT_HISTORY_FAILURE,
    LOAD_ACCOUNT_HISTORY_INFO_SUCCESS,
    LOAD_ACCOUNT_HISTORY_START,
    LOAD_ACCOUNT_HISTORY_SUCCESS,
} from "../../app/appConstants";
import { LOGOUT_SUCCESS } from "../Login/loginConstants";
import {
    ACCOUNT_GET_PORTFOLIO_SUCCESS,
    ACCOUNT_GET_TRADING_TOKEN_FAILURE,
    ACCOUNT_GET_TRADING_TOKEN_START,
    ACCOUNT_GET_TRADING_TOKEN_SUCCESS,
    PAYOUT_TRANSACTIONS_SUCCESS,
    REFILL_DEMO_FAILURE,
    REFILL_DEMO_START,
    REFILL_DEMO_SUCCESS,
    RESEND_USER_CONFIRM_EMAIL_FAILURE,
    RESEND_USER_CONFIRM_EMAIL_START,
    RESEND_USER_CONFIRM_EMAIL_SUCCESS,
    RESET_ACCOUNT_ERROR,
    SET_ACCOUNT_SELECTED_HISTORY_INFO,
    SET_CONFIRM_EMAIL_REQUEST_TIME,
} from "./accountConstants";
import type { IAccountState, IFullAccountActions } from './types/accountReducer.t';

const initialState: IAccountState = {
    portfolio: {},

    payments: {},
    transactionHistory: [],
    tradingToken: null,
    error: null,
    confirmEmailRequestTime: '',
    confirmEmailLoading: false,

    history: {
        initialized: false,
        isLoading: false,
        positions: [],
        transactions: [],
    },
    selectedHistoryInfo: {
        position: null,
        transaction: null,
    },

    refillDemoLoading: false,
};

const accountReducer = (state: IAccountState = initialState, action: IFullAccountActions) =>
    produce(state, (draft: IAccountState) => {
        switch (action.type) {

            case ACCOUNT_GET_PORTFOLIO_SUCCESS:
                draft.portfolio = action.payload;
                break;

            case ACCOUNT_GET_TRADING_TOKEN_START:
                draft.tradingTokenGetting = true;
                break;

            case ACCOUNT_GET_TRADING_TOKEN_SUCCESS:
                draft.tradingToken = action.payload;
                draft.tradingTokenGetting = false;
                break;

            case ACCOUNT_GET_TRADING_TOKEN_FAILURE:
                draft.tradingToken = null;
                draft.tradingTokenGetting = false;
                break;

            case PAYOUT_TRANSACTIONS_SUCCESS:
                draft.transactionHistory = action.payload.transactions;
                draft.payments = action.payload.payments;
                break;

            case LOGOUT_SUCCESS:
                return {
                    ...initialState,
                };

            case RESET_ACCOUNT_ERROR:
                draft.error = null;
                break;

            case RESEND_USER_CONFIRM_EMAIL_START:
                draft.confirmEmailLoading = true;
                break;
            case RESEND_USER_CONFIRM_EMAIL_SUCCESS:
                draft.confirmEmailLoading = false;
                break;
            case RESEND_USER_CONFIRM_EMAIL_FAILURE:
                draft.confirmEmailLoading = false;
                break;

            case SET_CONFIRM_EMAIL_REQUEST_TIME:
                draft.confirmEmailRequestTime = action.payload;
                break;

            case SET_ACCOUNT_SELECTED_HISTORY_INFO:
            case LOAD_ACCOUNT_HISTORY_INFO_SUCCESS:
                draft.selectedHistoryInfo[action.payload.type] = action.payload.info;
                break;

            case LOAD_ACCOUNT_HISTORY_START:
                draft.history.isLoading = true;
                break;

            case LOAD_ACCOUNT_HISTORY_SUCCESS:
                if (action.payload.positions) {
                    draft.history.positions = action.payload.positions;
                }
                if (action.payload.transactions) {
                    draft.history.transactions = action.payload.transactions;
                }
                draft.history.initialized = true;
                draft.history.isLoading = false;
                break;

            case LOAD_ACCOUNT_HISTORY_FAILURE:
                draft.history.initialized = true;
                draft.history.error = action.payload;
                draft.history.isLoading = false;
                break;

            case REFILL_DEMO_START:
                draft.refillDemoLoading = true;
                break;
            case REFILL_DEMO_SUCCESS:
            case REFILL_DEMO_FAILURE:
                draft.refillDemoLoading = false;
                break;

            default:
                return state;
        }
    });

export default accountReducer;
